import React from 'react';
import enhance from './enhance';
import styles from './styles.module.scss';
import { Link } from 'react-router-dom';

const ModelRow = ({
  locked,
  model,
  modelUrl,
  isSelected,
  submitted,
  selectedModelColor,
  mini,
}) => (
  <div className={mini ? styles.miniModel : styles.model}>
    {isSelected ? (
      <div className={styles.selectedModel} style={selectedModelColor}>
        <div>{model.description}</div>
        <div className={styles.sidebarModelQuota}>
          {locked ? 'Locked' : null} {submitted} / {model.quota}
        </div>
      </div>
    ) : (
      <Link to={modelUrl}>
        <div className={styles.unselectedModel}>
          <div>{model.description}</div>
          <div className={styles.sidebarModelQuota}>
            {locked ? 'Locked' : null} {submitted} / {model.quota}
          </div>
        </div>
      </Link>
    )}
  </div>
);

export default enhance(ModelRow);
